accordions = {
	init: function(){
		accordions.el();
	},
	el: function eventListenters(){
		$(".flex-headline").on('click', accordions.toggleAccordion);
	},
	toggleAccordion: function(){
		if($(this).parent('.collapsible-block').hasClass('open')){
			$(this).parent('.collapsible-block').removeClass('open');
			$(this).siblings('.collapsible-content').slideUp(1000);
		} else {
			$(this).parent('.collapsible-block').addClass('open');
			$(this).siblings('.collapsible-content').slideDown(1000);
		}
	},
};
